// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const carApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCars: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/car/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
    }),
    uploadCarData: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/car",
        method: "POST",
        body: { ...data },
      }),
    }),

    updateCarData: builder.mutation({
      query: () => ({
        url: "/api/v1/admin/car/update-car",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetCarsQuery,
  useUploadCarDataMutation,
  useDeleteCarDataMutation,
  useUpdateCarDataMutation,
} = carApiSlice;
